import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import ImportEsForm from "pages/import/components/ImportEsForm";
import ImportLocalForm from "pages/import/components/ImportLocalForm";
import ImportLabelsForm from "./components/ImportLabelsForm";
import LabelsSteps from "./components/LabelsSteps";
import ImportVideoForm from "pages/import/components/ImportVideoForm";
import { appPageRootStyles, appContainerHeight } from "../appBar/appBarTheme";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...appPageRootStyles(theme),
    },
    paper: {
      minWidth: "100%",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "column",      
      maxHeight: `calc(100vh - ${appContainerHeight(theme) + theme.spacing.unit * 2}px)`,
      overflow: "hidden",
    },
    formShell: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
    },
    formBody: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    formGrid: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
    },
    fileListSection: {
      display: "flex",
      flexDirection: "column",
      flex: "1 1 auto",
      minHeight: 0,
      overflow: "hidden",
    },
    fileListScroll: {
      flex: 1,
      width: "100%",
      minHeight: 240,
      overflow: "hidden",
      marginTop: 8,
      border: "1px solid #eee",
      borderRadius: 4,
      "& > div": {
        transition: "none !important",
        animation: "none !important",
      },
    },
    fileListOuter: {
      transition: "none !important",
      animation: "none !important",
    },
    formFooter: {
      flexShrink: 0,
      // borderTop: `1px solid ${theme.palette.divider}`,
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 4}px`,
      backgroundColor: theme.palette.background.paper,
    },
    formFooterRow: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing.unit * 2,
      minHeight: 40,
    },
    formFooterError: {
      flex: "1 1 auto",
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color: theme.palette.error.main,
      fontSize: 13,
    },
    formFooterActions: {
      display: "flex",
      gap: `${theme.spacing.unit}px`,
      flexShrink: 0,
      marginLeft: "auto",
    },
    formFooterButtonCancel: {
      width: 200,
      minWidth: 200,
    },
    formFooterButtonSubmit: {
      width: 300,
      minWidth: 300,
    },
    formFooterSubmitWrap: {
      display: "inline-block",
    },
    comment: {
      margin: "0px 16px",
      minHeight: 19,
      fontSize: 12,
    },
    marginTopNeg: {
      marginTop: "-16px",
    },
    title: {
      color: "white",
    },
    form: {
      padding: `${theme.spacing.unit * 4}px`,
      paddingBottom: 0,
    },
    input: {
      backgroundColor: "#FFF",
    },
    margin: {
      margin: theme.spacing.unit,
    },
    bootstrapRoot: {
      "label + &": {
        marginTop: theme.spacing.unit,
      },
    },
    bootstrapInput: {
      borderRadius: 4,
      backgroundColor: theme.palette.common.white,
      border: "1px solid rgba(72,72,72,.2)",
      fontSize: 16,
      padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
    bootstrapFormLabel: {
      fontSize: 18,
    },
    select: {
      width: "250px",
      borderRadius: 4,
      padding: "7px 7px",
      boxSizing: "border-box",
      // margin: "5px 0 0",
      fontSize: 16,
      position: "relative",
      border: "1px solid rgba(72,72,72,.2)",
      appearance: "none",
      color: "#444f59",
      background: "url(/assets/arrow-select.png) no-repeat 100%",
      "label + &": {
        marginTop: theme.spacing.unit,
      },
    },
    label: {
      fontWeight: 200,
      display: "block",
      fontSize: 16,
    },
    marginTop: {
      marginTop: theme.spacing.unit * 2,
    },
    dropContainer: {
      border: `dashed 1px ${theme.palette.grey[400]}`,
      marginTop: theme.spacing.unit * 2,
      padding: 0,
      minHeight: 125,
      borderRadius: "3px",
      fontSize: "1.4em",
      color: theme.palette.text.secondary,
    },
    uploading: {
      border: `solid 1px ${theme.palette.primary.main}`,
    },
    error: {
      color: theme.palette.error.main,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    warning: {
      color: "#ed6c02",
    },
    fileList: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "2px",
    },
    browseCrumbLink: {
      border: "none",
      background: "transparent",
      padding: "2px 4px",
      cursor: "pointer",
      color: "rgb(66, 65, 65)",
      fontSize: 14,
      "&:hover": {
        color: "#2948FF",
      },
    },
    issueChipIcon: {
      color: "#ed6c02",
      fontSize: 18,
      marginLeft: 8,
    },
    issueChipExpandIcon: {
      color: "#ed6c02",
    },
    issueChipGroup: {
      display: "inline-flex",
      alignItems: "center",
      gap: "2px",
    },
    issueChipRemoveButton: {
      padding: 4,
      color: "#ed6c02",
    },
    filePreviewButton: {
      padding: 4,
    },
    filePreviewDialogTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 8,
      paddingRight: 8,
    },
    filePreviewDialogTitleText: {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: 20,
      fontWeight: 500,
    },
    filePreviewDialogCloseButton: {
      flexShrink: 0,
    },
    filePreviewImage: {
      display: "block",
      maxWidth: "100%",
      maxHeight: "70vh",
      margin: "0 auto",
      objectFit: "contain",
    },
  });

const Import = (props: any) => {  
  switch (props.type) {
    case "es":
      return <ImportEsForm {...props} />;
    case "dossierlocal":
      return <ImportLocalForm {...props} />;
    case "video":
      return <ImportVideoForm {...props} />;
    case "labels":
      return <LabelsSteps {...props} />;
    default:
      return null;
  }
};

export default withStyles(styles)(withRouter(Import));
